<div class="card {{class}}">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
    <div *ngIf="title != '' || description != ''"
      class="m-1 d-flex align-items-baseline justify-content-start flex-column flex-sm-row text-left flex-wrap">
      <h2 *ngIf="title != ''" class="m-0 mr-2">{{title | slice:0:100 | uppercase}}</h2>
      <small *ngIf="description != ''" class="title-description" style="max-width: 600px;">{{description |
        slice:0:200}}</small>
    </div>
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Buscar</mat-label>
      <input matInput type="text" placeholder="Buscar" (keyup)="applyFilter($event)" #input>
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <div class="card-body text-center" *ngIf="data.length==0">
    No hay registros que mostrar
  </div>

  <div class="card-body overflow-auto p-0">
    <table mat-table *ngIf="data.length>0" [dataSource]="dataSource">

      <ng-container matColumnDef="{{item.name}}" *ngFor="let item of columns">
        <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">{{item.title|uppercase}}</th>
        <td mat-cell *matCellDef="let element" [ngClass]="{'text-break': render(item, element).length>40,
                  'text-wrap':render(item, element).length>20, 'text-nowrap':render(item, element).length<=20}"
          class="p-1 pr-3 pl-3">
          <span class="mobile-label mr-2">{{item.title|uppercase}}:</span>
          {{render(item, element)}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.demo-row-is-clicked]="selected.has(row)"
        (click)="addRowToItems(row)"></tr>
    </table>


  </div>
  <mat-paginator [pageSizeOptions]="pageSizeOptions.length>0?pageSizeOptions:[5, 10, 20]" showFirstLastButtons
    aria-label="Select page of periodic elements" class="card-footer">
  </mat-paginator>
</div>